import React from 'react'

import './Footer.css'

import succubus_logo from "../../../images/succubus-footer-logo.png"
import AppState, { POPUPS } from '../../../js/AppState';
import Texts from 'react-sdk/Texts';




/* import logo_hugo_roman from './hugo_roman.jpg' */
import logo_hugo_roman from './logo hr.png'
import PopupsManager from 'react-sdk/PopupsManager';






const Footer = () => {


  function openMentionsPopup(e) {
    e.preventDefault()

    PopupsManager.open(POPUPS.MENTIONS_LEGALES, { data: "data"})
  }


  return (
    <div className="Footer">
      <div className="menu-bottom">
        <a href="#" onClick={openMentionsPopup}>{Texts.get("mentions-legales-button")}</a>
      </div>

      <div className="logos">
        <a href={Texts.get("footer-link-hugo-roman")} target="_blank" className="logo"><img src={logo_hugo_roman} alt="logo DGFIP" /></a>
      </div>


      <div className="baseline">
        <img src={succubus_logo} alt="logo-succcubus" />
        <div>Seriously made with fun by <a href="https://www.ludicius.com" target='_blank'>Ludicius</a></div>
      </div>
    </div>
  );
};

export default Footer;
